import React, { Component } from 'react';
import { Divider, Form, Header, Responsive, Segment, Tab } from 'semantic-ui-react';
import Grades from './Grades';
import { ToastContainer } from 'react-toastify';
import axios from 'axios';
import { fetchAcademicYears } from '../../../Lookups/util';
import { fetchSemesters } from '../../../StudentService/StudentServiceInputGrades/InputGradesFilterStudents';
import CourseEnrollment from '../CourseEnrollment/CourseEnrollment';

class InputGradesAdminPanel extends Component {
    constructor(props, context) {
        super(props, context);
        this.state = {
            semesterKey: null,
            academicYearId: null,
            loading: true
        };
        this.handleInputChange = this.handleInputChange.bind(this);
        this.fetchUngradedCourseImplementations = this.fetchUngradedCourseImplementations.bind(this);
    }

    componentDidMount() {
        axios.all([fetchAcademicYears(), fetchSemesters()])
            .then(axios.spread((yearsRes, semRes) => {
                const academicYears = yearsRes.data.map(el => ({
                    key: el.id, value: el.id, text: el.name
                })).reverse();

                const semesters = semRes.data.filter(e => e.name.name !== 'ostalo').map(el => ({
                    key: el.name._key, value: el.name._key, text: el.name.name
                }));

                this.setState({
                    academicYears,
                    semesters,
                    semesterKey: semesters[0].value

                }, () => {
                    axios.get('/academic-years/current')
                        .then(res => {
                            this.setState({ academicYearId: res.data.id }, () => { this.fetchUngradedCourseImplementations(); });
                        });
                });
            }))
            .catch(err => {
                console.log('Failed to fetch academic year or semesters or faculties.');
            });
    }

    fetchUngradedCourseImplementations() {
        let student = JSON.parse(localStorage.getItem('student'));

        let docFilter = {
            semesterKey: this.state.semesterKey,
            academicYearId: this.state.academicYearId,
            studentStudyProgramId: student.studentStudyProgramId ? student.studentStudyProgramId : student.id
        };

        axios.post('/grade-student/ungraded/course-implementations/', { ...docFilter })
            .then(res => {
                this.setState({
                    ungradedCourseImplementations: res.data.map((el) => ({
                        ...el,
                        key: el.courseImplementationId,
                        value: el.courseImplementationId,
                        text: el.courseBasicName
                    })),
                    data: res.data,
                    loading: false,
                    update: false
                });
            })
            .catch(err => {
                console.log('Failed to fetch courses');
            });
    }

    handleInputChange(event, { name, value }) {
        this.setState({
            [name]: value,
            update: true
        }, () => {
            if (name === 'semesterKey') { this.fetchUngradedCourseImplementations(); localStorage.setItem('semesterKey', value); }
            if (name === 'academicYearId') { this.fetchUngradedCourseImplementations(); localStorage.setItem('academicYearId', value); }
        });
    }

    render() {
        const { semesterKey, academicYearId } = this.state;
        const student = JSON.parse(localStorage.getItem('student'));
        return (
            <div>
                {!this.props.hideHeader && <h1>Unos ocjena</h1>}
                <Segment.Group raised={!this.props.hideSegments}>
                    {!this.props.hideSegments && <Segment>
                        <Header as="h3">
                            {student.firstName} {student.lastName} - {student.index}
                            <Header.Subheader>
                                Ime i prezime studenta, index
                            </Header.Subheader>
                        </Header>
                    </Segment>}
                    <Segment >
                        <Form>

                            <Form.Group widths="equal">

                                <Form.Field required>
                                    <label>Akademska godina</label>
                                    <Form.Dropdown
                                        placeholder="Odaberite akademsku godinu"
                                        value={academicYearId}
                                        onChange={this.handleInputChange}
                                        name="academicYearId"
                                        options={this.state.academicYears}
                                        search
                                        fluid
                                        selection
                                        error={this.state.academicYearErr}
                                    />
                                </Form.Field>
                                <Form.Field required>
                                    <label>Semestar</label>
                                    <Form.Dropdown
                                        placeholder="Odaberite semestar"
                                        value={semesterKey}
                                        onChange={this.handleInputChange}
                                        name="semesterKey"
                                        options={this.state.semesters}
                                        search
                                        fluid
                                        selection
                                        error={this.state.semesterErr}
                                    />
                                </Form.Field>
                            </Form.Group>
                        </Form>
                    </Segment>
                    <Segment >
                        <Grades
                            update={this.state.update}
                            ungradedCourseImplementations={this.state.ungradedCourseImplementations}
                            fetchUngradedCourseImplementations={this.fetchUngradedCourseImplementations}
                        />
                        {/* <Tab menu={{ secondary: true, pointing: true, color: 'blue' }} panes={panes} activeIndex={this.state.activeIndex} defaultActiveIndex={2} onTabChange={this.handleTabChange} /> */}
                    </Segment>
                    <ToastContainer hideProgressBar />
                </Segment.Group>
            </div>
        );
    }
}

export default InputGradesAdminPanel;



// WEBPACK FOOTER //
// ./src/views/Admin/Students/InputGrades/InputGradesAdminPanel.js